function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { elementToXPath, XPathToArray } from './utils';
import Schema from './schema';
import Debug from './debug';
import Deprecate from './deprecate';

var multipleInstances = function multipleInstances(element) {
  if (['checkbox', 'radio'].includes(element.type)) {
    return document.querySelectorAll("input[type=\"".concat(element.type, "\"][name=\"").concat(element.name, "\"]")).length > 1;
  }

  return false;
};

var collectCheckedOptions = function collectCheckedOptions(element) {
  return Array.from(element.querySelectorAll('option:checked')).concat(Array.from(document.querySelectorAll("input[type=\"".concat(element.type, "\"][name=\"").concat(element.name, "\"]"))).filter(function (elem) {
    return elem.checked;
  })).map(function (o) {
    return o.value;
  });
}; // Returns a string value for the passed array.
//
//   attributeValue(['', 'one', null, 'two', 'three ']) // 'one two three'
//


var attributeValue = function attributeValue() {
  var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var value = values.filter(function (v) {
    return v && String(v).length;
  }).map(function (v) {
    return v.trim();
  }).join(' ').trim();
  return value.length ? value : null;
}; // Returns an array for the passed string value by splitting on whitespace.
//
//   attributeValues('one two three ') // ['one', 'two', 'three']
//


var attributeValues = function attributeValues(value) {
  if (!value) return [];
  if (!value.length) return [];
  return value.split(' ').filter(function (v) {
    return v.trim().length;
  });
}; // Extracts attributes from a DOM element.
//


var extractElementAttributes = function extractElementAttributes(element) {
  var attrs = Array.from(element.attributes).reduce(function (memo, attr) {
    memo[attr.name] = attr.value;
    return memo;
  }, {});
  attrs.checked = !!element.checked;
  attrs.selected = !!element.selected;
  attrs.tag_name = element.tagName;

  if (element.tagName.match(/select/i) || multipleInstances(element)) {
    var collectedOptions = collectCheckedOptions(element);
    attrs.values = collectedOptions;
    attrs.value = collectedOptions.join(',');
  } else {
    attrs.value = element.value;
  }

  return attrs;
}; // Returns an array of elements for the provided tokens.
// Tokens is an array of space separated string coming from the `data-reflex-dataset`
// or `data-reflex-dataset-all` attribute.
//


var getElementsFromTokens = function getElementsFromTokens(element, tokens) {
  if (!tokens || tokens.length === 0) return [];
  var elements = [element];
  var xPath = elementToXPath(element);
  tokens.forEach(function (token) {
    try {
      switch (token) {
        case 'combined':
          if (Deprecate.enabled) console.warn("In the next version of StimulusReflex, the 'combined' option to data-reflex-dataset will become 'ancestors'.");
          elements = [].concat(_toConsumableArray(elements), _toConsumableArray(XPathToArray("".concat(xPath, "/ancestor::*"), true)));
          break;

        case 'ancestors':
          elements = [].concat(_toConsumableArray(elements), _toConsumableArray(XPathToArray("".concat(xPath, "/ancestor::*"), true)));
          break;

        case 'parent':
          elements = [].concat(_toConsumableArray(elements), _toConsumableArray(XPathToArray("".concat(xPath, "/parent::*"))));
          break;

        case 'siblings':
          elements = [].concat(_toConsumableArray(elements), _toConsumableArray(XPathToArray("".concat(xPath, "/preceding-sibling::*|").concat(xPath, "/following-sibling::*"))));
          break;

        case 'children':
          elements = [].concat(_toConsumableArray(elements), _toConsumableArray(XPathToArray("".concat(xPath, "/child::*"))));
          break;

        case 'descendants':
          elements = [].concat(_toConsumableArray(elements), _toConsumableArray(XPathToArray("".concat(xPath, "/descendant::*"))));
          break;

        default:
          elements = [].concat(_toConsumableArray(elements), _toConsumableArray(document.querySelectorAll(token)));
      }
    } catch (error) {
      if (Debug.enabled) console.error(error);
    }
  });
  return elements;
}; // Extracts the dataset of an element and combines it with the data attributes from all specified tokens
//


var extractElementDataset = function extractElementDataset(element) {
  var dataset = element.attributes[Schema.reflexDataset];
  var allDataset = element.attributes[Schema.reflexDatasetAll];
  var tokens = dataset && dataset.value.split(' ') || [];
  var allTokens = allDataset && allDataset.value.split(' ') || [];
  var datasetElements = getElementsFromTokens(element, tokens);
  var datasetAllElements = getElementsFromTokens(element, allTokens);
  var datasetAttributes = datasetElements.reduce(function (acc, ele) {
    return _objectSpread(_objectSpread({}, extractDataAttributes(ele)), acc);
  }, {});
  var reflexElementAttributes = extractDataAttributes(element);
  var elementDataset = {
    dataset: _objectSpread(_objectSpread({}, reflexElementAttributes), datasetAttributes),
    datasetAll: {}
  };
  datasetAllElements.forEach(function (element) {
    var elementAttributes = extractDataAttributes(element);
    Object.keys(elementAttributes).forEach(function (key) {
      var value = elementAttributes[key];

      if (elementDataset.datasetAll[key] && Array.isArray(elementDataset.datasetAll[key])) {
        elementDataset.datasetAll[key].push(value);
      } else {
        elementDataset.datasetAll[key] = [value];
      }
    });
  });
  return elementDataset;
}; // Extracts all data attributes from a DOM element.
//


var extractDataAttributes = function extractDataAttributes(element) {
  var attrs = {};

  if (element && element.attributes) {
    Array.from(element.attributes).forEach(function (attr) {
      if (attr.name.startsWith('data-')) {
        attrs[attr.name] = attr.value;
      }
    });
  }

  return attrs;
};

export { attributeValue, attributeValues, extractElementAttributes, extractElementDataset, extractDataAttributes };